import { getObjectUtil } from 'packages/src'
import setReduxAction from '../set'
import validateReduxUtil from '../../utils/validate'

/**
 * Validates the object at the given path.
 * @param {Object} action
 *        {string} action.path
 *        {Object} [action.options]
 */
function validateReduxAction (action) {
  return (dispatch, getState) => {
    const { payload } = action
    const {
      path,
      options
    } = payload

    const instance = getObjectUtil(getState(), path)
    if (!instance) {
      return
    }

    const validation = validateReduxUtil(instance, options)
    if (!validation) {
      return
    }

    const validationPath = `${path}.validation`
    dispatch(setReduxAction({
      type: action.type,
      payload: {
        path: validationPath,
        value: validation
      }
    }))

    return validation
  }
}

export default validateReduxAction
